import * as actions from './Actions';

// Normalize requirement payload from API to frontend shape
const parseRequirement = (payload) => {
  const idRaw = payload.skill_poste_id ?? payload.id;
  const id = idRaw !== undefined && idRaw !== null && !Number.isNaN(Number(idRaw)) ? Number(idRaw) : idRaw;
  // Normalize required_level: accept number 1..3 or label strings
  const normalizeLevel = (val) => {
    const n = Number(val);
    if (!Number.isNaN(n) && n >= 1 && n <= 3) return n;
    const s = String(val || '').toLowerCase();
    if (s.includes('awareness')) return 1;
    if (s.includes('skilled')) return 2;
    if (s.includes('management')) return 3;
    return val; // keep as-is if unknown
  };
  return {
    id, // requirement id
    skill_id: payload.skill_id !== undefined ? Number(payload.skill_id) : undefined,
    poste_id: payload.poste_id !== undefined ? Number(payload.poste_id) : undefined,
    required_level: payload.required_level !== undefined ? normalizeLevel(payload.required_level) : undefined,
    min_score: payload.min_score !== undefined ? Number(payload.min_score) : undefined,
    max_score: payload.max_score !== undefined ? Number(payload.max_score) : undefined,
    // Optionally attached objects if the caller enriches them
    skill: payload.skill || null,
    poste: payload.poste || null,
    createdAt: payload.createdAt,
    updatedAt: payload.updatedAt,
  };
};

export const requirementsReducer = (state = [], action) => {
  switch (action.type) {
    case actions.INITIALIZE_REQUIREMENTS: {
      const list = Array.isArray(action.payload) ? action.payload : [];
      const parsed = list.map((r) => parseRequirement(r));
      return parsed;
    }

    case actions.ADD_REQUIREMENT: {
      const item = parseRequirement(action.payload);
      return [...state, item];
    }

    case actions.UPDATE_REQUIREMENT: {
      const updated = parseRequirement(action.payload);
      const next = state.map((r) => (r.id === updated.id ? { ...r, ...updated } : r));
      return next;
    }

    case actions.DELETE_REQUIREMENT: {
      const reqId = action.payload?.id ?? action.payload?.skill_poste_id ?? action.id;
      const next = state.filter((r) => r.id !== reqId);
      return next;
    }

    case actions.CLEAR_REQUIREMENTS_LIST: {
      return [];
    }

    default:
      return state;
  }
};

